// src/components/operatorComboBox.js
// Igual que OperatorList2, pero como input editable: permite elegir de la
// lista desplegable (datalist) o digitar el codigo de operador manualmente.
import React, { useEffect, useId, useState, useContext } from "react";
import { getOperatorsL } from "../api";
import { LanguageContext } from "../context/LanguageContext";

const OperatorComboBox = ({ id_c, value, onSelect }) => {
  const { t } = useContext(LanguageContext);
  const [data, setData] = useState(null);
  const datalistId = useId();

  useEffect(() => {
    const fetchData = async () => {
      const res = await getOperatorsL(id_c); // { operators, total }
      setData(res);
    };
    if (id_c) fetchData();
  }, [id_c]);

  if (!data) return <p>{t("MList1") || "Cargando..."}</p>;

  // Nombre del operador que corresponde al codigo actual (si existe en la lista)
  const matched = data.operators.find(
    (op) => String(op.id_operator) === String(value)
  );

  return (
    <>
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <input
          className="input1"
          type="text"
          list={datalistId}
          value={value || ""}
          onChange={(e) => onSelect(e.target.value)}
          placeholder={t("operator1") || "Selecciona o digita el operador"}
          autoComplete="off"
          required
          style={{ width: "50%", flex: "0 0 50%", textAlign: "center" }}
        />
        {matched && (
          <span style={{ flex: 1, textAlign: "center", fontSize: "0.85em", opacity: 0.75, whiteSpace: "nowrap" }}>
            {matched.name_oper}
          </span>
        )}
      </div>
      <datalist id={datalistId}>
        {data.operators.map((op) => (
          <option key={op.id_operator} value={op.id_operator}>
            {op.id_operator} — {op.name_oper}
          </option>
        ))}
      </datalist>
    </>
  );
};

export default OperatorComboBox;
